import React, { memo, useContext, useState } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { CTA } from '../../interfaces/CTA.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import ProgressBar from './ProgressBar';
import FormFieldTextInput from '../FormFields/FormFieldTextInput/FormFieldTextInput';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import SbImage from '../SbImage/SbImage';
import { QuickQuoteContext, Service } from '../../contexts/QuickQuote.context';
import { useFormikContext } from 'formik';
import classNames from 'classnames';

interface QuickQuoteMultiSelectCardBtnProps {
  name: string;
  option: string;
  service: Service;
  label: string;
  description: string;
  icon: StoryblokAsset;
}

const QuickQuoteMultiSelectCardBtn: React.FC<
  QuickQuoteMultiSelectCardBtnProps
> = ({ name, option, service, label, description, icon }) => {
  const { setService, setQuoteStep, quoteStep } = useContext(QuickQuoteContext);
  const { setFieldValue } = useFormikContext();
  const [isSelected, setIsSelected] = useState<boolean>(false);

  return (
    <button
      className={classNames(
        'bg-system/white w-full hover:cursor-pointer rounded-[8px] shadow-sm border border-system/white transition-all',
        {
          '!border-[#009bef]': isSelected,
        }
      )}
      onClick={() => {
        setFieldValue(name, !isSelected);
        setIsSelected((prev) => !prev);
      }}
      type="button"
    >
      <div className="flex py-5 px-3">
        <div className="flex-shrink-0 pt-[2px]">
          <SbImage
            asset={icon}
            options={{
              objectFit: 'contain',
              width: 17,
              height: 17,
              sizes: { base: 17 },
            }}
          />
        </div>
        <div className="ml-4 pr-6">
          <p className="text-left font-bold">{label}</p>
          {description && <p className="text-left text-sm">{description}</p>}
        </div>
      </div>
    </button>
  );
};

export default withBlokWrapper(QuickQuoteMultiSelectCardBtn, Theme.ALT);
